export default __webpack_public_path__ + "static/media/softclix_lancets.fd6da93b.webp";